import type { ButtonHTMLAttributes } from "react";

type Variant = "primary" | "ghost" | "danger" | "outline";
type Size = "lg" | "md" | "sm";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  fullWidth?: boolean;
}

const VARIANT: Record<Variant, string> = {
  primary:
    "bg-white text-black shadow-lg shadow-white/10 hover:shadow-white/20 disabled:opacity-40",
  ghost: "bg-white/10 text-white hover:bg-white/15 disabled:opacity-40",
  outline: "border border-white/30 text-white hover:bg-white/10 disabled:opacity-40",
  danger: "bg-red-500 text-white hover:bg-red-600 disabled:opacity-40",
};

const SIZE: Record<Size, string> = {
  lg: "px-6 py-4 text-lg rounded-2xl font-bold",
  md: "px-5 py-3 text-base rounded-xl font-semibold",
  sm: "px-3 py-2 text-sm rounded-lg font-semibold",
};

export function Button({
  variant = "primary",
  size = "lg",
  fullWidth,
  className,
  ...rest
}: Props) {
  return (
    <button
      {...rest}
      className={`pp-btn transition active:scale-95 ${VARIANT[variant]} ${SIZE[size]} ${
        fullWidth ? "w-full" : ""
      } ${className ?? ""}`}
    />
  );
}
